import React, { Fragment } from 'react';
import { Row, Col, Table } from 'reactstrap';
import { formattedDateOnly } from '../../../../../utilities/formatedDate';


const ProposerDetails = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            <tr>
                                <th>Title</th>
                                <td className="text-right pr-5">
                                    {data?.proposers[0]?.proposer_title ? data?.proposers[0]?.proposer_title : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>First Name</th>
                                <td className="text-right pr-5">
                                {data?.proposers[0]?.proposer_first_name ? data?.proposers[0]?.proposer_first_name : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Middle Name</th>
                                <td className="text-right pr-5">
                                    {data?.proposers[0]?.proposer_middle_name ? data?.proposers[0]?.proposer_middle_name : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Last Name</th>
                                <td className="text-right pr-5">
                                {data?.proposers[0]?.proposer_last_name ? data?.proposers[0]?.proposer_last_name : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>{data?.proposers?.[0]?.proposer_oci ? 'OCI No' : 'Passport No'}</th>
                                <td className="text-right pr-5">
                                    {data?.proposers[0]?.proposer_passport_number ? data?.proposers[0]?.proposer_passport_number : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Email</th>
                                <td className="text-right pr-5">
                                    {data?.proposers[0]?.proposer_email ? data?.proposers[0]?.proposer_email : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Mobile</th>
                                <td className="text-right pr-5">
                                    {data?.proposers[0]?.proposer_mobile ? data?.proposers[0]?.proposer_mobile : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>Address</th>
                                <td className="text-right pr-5">
                                    {data?.proposers[0]?.proposer_address ? data?.proposers[0]?.proposer_address : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>DOB</th>
                                <td className="text-right pr-5">
                                    {data?.proposers[0]?.proposer_dob ? formattedDateOnly(data?.proposers[0]?.proposer_dob) : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td className="text-right pr-5">
                                    {data?.proposers[0]?.state ? data?.proposers[0]?.state : '-'}
                                </td>
                            </tr>
                            <tr>
                                <th>City</th>
                                <td className="text-right pr-5">
                                    {data?.proposers[0]?.city ? data?.proposers[0]?.city : '-'}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default ProposerDetails;